import { render, staticRenderFns } from "./moduleTutorial.vue?vue&type=template&id=5a506acf&scoped=true&"
import script from "./moduleTutorial.vue?vue&type=script&lang=js&"
export * from "./moduleTutorial.vue?vue&type=script&lang=js&"
import style0 from "./moduleTutorial.vue?vue&type=style&index=0&id=5a506acf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a506acf",
  null
  
)

export default component.exports